export default __webpack_public_path__ + "static/media/193-ireland.8cc11855.svg";